import apiCall from "../utils/api-call/apiCall";
import { createHeaders } from "./constants";

const generateApiKeyAndToken = async () => {
  const headers = createHeaders();
  return await apiCall('generate-keys', 'GET', {}, headers);
};

export { generateApiKeyAndToken };